import { useEffect, useState } from "react";
import "../assets/styles/components/notifications-panel.scss";
import { NavLink } from "react-router-dom";
import NotificationCard from "./NotificationsCard";

export default function NotificationsPanel({
  closeNotification,
  notifications,
}) {
  const [close_notifications_effect, setCloseNotificationsEffect] =
    useState("");

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handleCloseNotifications = () => {
    setCloseNotificationsEffect("close-effect");
    setTimeout(() => {
      document.body.style.overflow = "auto";
      closeNotification();
    }, 500);
  };

  return (
    <div
      onClick={() => handleCloseNotifications()}
      className={`notifications-panel position-fixed w-100 h-100 py-4 d-flex justify-content-center align-items-center ${close_notifications_effect}`}
    >
      <div className="notifications-panel__content shadow-lg position-fixed overflow-auto">
        {notifications && notifications.length > 0 ? (
          notifications.map((item, index) => {
            if (index < 5)
              return (
                <NavLink
                  to="/notifications"
                  state={{ notifications_list: notifications, selected: item }}
                >
                  <NotificationCard notification_info={item} key={index} />
                </NavLink>
              );
          })
        ) : (
          <div className="empty-panel px-3 py-4 d-flex justify-content-center">
            <span>Non sono presenti notifiche</span>
          </div>
        )}
        {notifications && notifications.length > 0 ? (
          <NavLink
            className="px-3 py-3 d-block text-center"
            to="/notifications"
            state={{ notifications_list: notifications }}
          >
            Vedi tutte le notifiche
          </NavLink>
        ) : null}
      </div>
    </div>
  );
}
